import { useState } from "react";
import { Loader2, Lock } from "lucide-react";
import { http, setToken, errText } from "@/lib/api";
import { Field } from "@/components/landing/WaitlistParts";

export const AdminLogin = ({ onLogin }) => {
  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");
  const [error, setError] = useState("");
  const [busy, setBusy] = useState(false);

  const submit = async (e) => {
    e.preventDefault();
    setBusy(true);
    setError("");
    try {
      const { data } = await http.post("/auth/login", { email, password });
      setToken(data.token);
      onLogin(data);
    } catch (err) {
      setError(errText(err));
    } finally {
      setBusy(false);
    }
  };

  return (
    <div className="min-h-screen bg-[#13296B] flex items-center justify-center p-5">
      <form onSubmit={submit} className="w-full max-w-md rounded-[28px] bg-white p-8 sm:p-10 space-y-5" data-testid="admin-login-form">
        <div className="flex items-center gap-3">
          <img src="/brand/logo.png" alt="Marketgetr" className="h-12 w-12 object-cover scale-125 rounded-xl" />
          <div>
            <p className="font-display text-2xl font-extrabold text-[#13296B]">Sign-up monitor</p>
            <p className="text-sm text-slate-500">Marketgetr team only</p>
          </div>
        </div>
        <Field label="Email" type="email" testId="admin-email-input" value={email} onChange={(e) => setEmail(e.target.value)} required />
        <Field label="Password" type="password" testId="admin-passcode-input" value={password} onChange={(e) => setPassword(e.target.value)} required />
        {error && <p className="text-sm text-red-600" data-testid="admin-login-error">{error}</p>}
        <button type="submit" disabled={busy} data-testid="admin-login-btn" className="w-full flex items-center justify-center gap-2 rounded-full bg-[#2F7FF0] text-white font-bold py-3.5 hover:bg-[#13296B] transition-colors duration-300 disabled:opacity-60">
          {busy ? <Loader2 className="h-5 w-5 animate-spin" /> : <Lock className="h-4 w-4" />} Sign in
        </button>
        <a href="/" className="block text-center text-sm text-slate-500 hover:text-[#13296B]" data-testid="admin-back-home-link">Back to site</a>
      </form>
    </div>
  );
};
